module.exports = __webpack_public_path__ + "img/home.95fd6832.svg";